export const lerp = (a: number, b: number, t: number) => a * (1 - t) + t * b

export const clamp = (x: number, min:number, max:number) =>
	min < max ? Math.min(Math.max(x, min), max) : Math.min(Math.max(x, max), min)

export const map = (n: number, start1: number, stop1: number, start2: number, stop2: number) =>
	clamp(((n - start1) / (stop1 - start1)) * (stop2 - start2) + start2, start2, stop2)

export const precision = (value: number, floats = 3) => {
	const pow = Math.pow(10, floats)
	return ~~(value * pow) / pow
}

export const damp = (a, b, lambda, dt) => {
	return lerp(a, b, 1 - Math.exp(-lambda * dt))
}

export const toRem = (value: number, asString = true): number | string => {
	const res = value ? (value * 0.16).toFixed(1) : 0
	return asString ? `${res}rem` : res
}

export const randomRange = (min = 0, max = 1) => precision(Math.random() * (max - min) + min, 2)

/**
 * Cubic bezier easing function generator.
 * Use it like the css equivalent: cubic-bezier(t, x1, y1, x2, y2).
 */
export const cubicBezier = (t:number, x1:number, y1:number, x2:number, y2:number):number => {
	const u = 1 - t
	const tt = t * t
	const uu = u * u
	const uuu = uu * u
	const ttt = tt * t

	let p = uuu * y1 // (1-t)^3 * y1
	p += 3 * uu * t * x1 // 3 * (1-t)^2 * t * x1
	p += 3 * u * tt * x2 // 3 * (1-t) * t^2 * x2
	p += ttt * y2 // t^3 * y2

	return p
}

/** @function wrap - if `value` if below or above the range it wraps it around,
 * e.g wrap(12, 0, 10) => 2
 */
export const wrap = (value: number, min: number, max: number): number => {
	const rangeSize = max - min
	return ((((value - min) % rangeSize) + rangeSize) % rangeSize) + min
}

export const calcIndexRotation = (index: number, length: number, amount = 3) => {
	const midPoint = Math.floor(length / 2)
	const offset = length % 2 === 0 ? amount : 0
	const rotation = (index - midPoint) * amount + offset
	return rotation
}
